// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n:root{\n  --header-height-sm:80px;\n  --header-height:96px\n}\n.bg-section{\n  position:relative\n}\n.bg-section:before{\n  position:absolute;\n  top:0;\n  left:0;\n  z-index:10;\n  width:100%;\n  height:20%;\n  content:\"\";\n  background:linear-gradient(#0f0e14,rgba(15,14,20,0))\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
